import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import cx from 'classnames';
import styles from './RightSideBar.module.scss';
import { card } from '../Forum.module.scss';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import UserImg from '../UserImg/UserImg';
// import { Link } from 'react-router-dom';
import { getTop } from 'redux/modules/forum';

const SettingUpComponent = ({ settingUp }) => {
  return null;
  // return (
  //   <div className={cx(styles.settingup, card)}>
  //     <div>Finish Setting Up Your Account</div>
  //     <div>
  //       {settingUp.map(({ text, check }) => (
  //         <div key={text}>
  //           <FontAwesomeIcon
  //             icon="check"
  //             className={cx(!check && styles.unselect)}
  //           />
  //           <span>{text}</span>
  //         </div>
  //       ))}
  //     </div>
  //   </div>
  // );
};

const SettingUp = connect(({ forum: { settingUp } }) => ({ settingUp }))(
  SettingUpComponent
);

const SideBarComponent = ({ getTop, topTutors }) => {
  useEffect(() => {
    getTop();
  }, [getTop]);
  return (
    <div>
      {/* <div className={cx(styles.tutors, card)}>
        <div>This Week's Top Tutors</div>
        <div>
          {topTutors.map(({ name, avatar, _id }, i) => (
            <div key={name}>
              <span>{i + 1}</span>
              <Link to={`/users/${_id}/profile`}>
                <UserImg alt={{ name, avatar }} />
                {name}
              </Link>
            </div>
          ))}
        </div>
      </div> */}
      <div className={cx(styles.text, card)}>
        <div>Welcome To SmartGuppy's Q&A Page!</div>
        <div>
          Post your school-related questions here and have them answered by
          other tutors and students!
          <br />
          <br />
          For tutors, stand a chance to be featured as a top tutor by providing
          quick and accurate answers!
        </div>
      </div>
    </div>
  );
};

SideBarComponent.propTypes = {
  topTutors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      avatar: PropTypes.string.isRequired,
      _id: PropTypes.string.isRequired,
    })
  ),
};

SideBarComponent.defaultProps = {
  topTutors: [],
};

const SideBar = connect(
  ({ entities: { users }, forum: { topTutors } }) => ({
    topTutors: topTutors.map(user => users[user]).filter(Boolean),
  }),
  { getTop }
)(SideBarComponent);

const RightSideBar = ({ settingUpDone, match: { url } }) => {
  return (
    <div className={styles.mainContainer}>
      {url === '/forum' && !settingUpDone ? <SettingUp /> : <SideBar />}
    </div>
  );
};

export default withRouter(
  connect(({ forum: { settingUp }, auth: { user } }) => ({
    settingUpDone: !user || !settingUp.find(({ check }) => !check),
  }))(RightSideBar)
);
